export default __webpack_public_path__ + "static/team-alyse-7919facaf0ef3e77aa50fa19214cdd58.png";